import React, {useEffect, useState} from "react";

const PanelLeftContent = ({...props}) => {
  const [top, setTop] = useState('0');
  useEffect(()=>{
    const scrollHandle = ()=>{
      let topCalc = document.querySelector(".panel_header").getBoundingClientRect().bottom;
      if(topCalc > 0){
        setTop(topCalc + 10);
      }else{
        setTop(10);

      }
    }
    scrollHandle();
    window.addEventListener("scroll", scrollHandle, true);
    return ()=> window.removeEventListener("scroll", scrollHandle, true);
  }, []);
  return (
    <div className="left_content">
      <div className="left_content_box main_box" style={{top}}>{props.children}</div>
    </div>
  );
};

export default PanelLeftContent;
